import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Icon from '../../../generic-components/Icon';
import ErrorIcon from '../../../assets/icons/svg/stamp-icons/ic-stamp-alert.svg';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';
import { VIEWS_MAP } from '../../../router/constants';

export const LimitReached = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <>
      <Icon className='w-[80px] mb-[24px]' src={ErrorIcon} />
      <Heading title={t('MAIL_CHECK.LIMIT_REACHED.TITLE')} className='font-metricR text-[24px] text-bw08 mb-[8px]' />
      <Heading title={t('MAIL_CHECK.LIMIT_REACHED.MESSAGE')} className='font-metricR text-[18px] text-bw07 mb-[60px]' />
      <Button
        onClick={() => navigate(`/${VIEWS_MAP.DASHBOARD}`)}
        className='w-[280px] text-bw00 bg-action03 hover:bg-action04 py-[17px] rounded-[4px] font-metricR text-[16px]'
        title={t('MAIL_CHECK.LIMIT_REACHED.CTA')}
        id='limitReachConfirmation'
      />
    </>
  );
};
